/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { billingCountryDataCodeSchema } from './BillingCountryDataCodeSchema'

export const billingCountryDataSchema = z.object({
	code: billingCountryDataCodeSchema,
	eu: z.boolean(),
})

export type BillingCountryDataSchema = z.infer<typeof billingCountryDataSchema>
